import {useParams} from 'react-router-dom';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {isDev} from 'utils/constants';
import styles from './instrumentV2.module.scss';

/**
 * Sticky footer for an instrument form. Keeps the primary action reachable on
 * long screens and says what is still outstanding, so nothing fails silently
 * on submit.
 *
 * `onPrepopulate` adds a dev-only shortcut that fills the screen with sample
 * data — see devPrefill.js. It is hidden on production builds and while
 * editing a saved record, so it can never overwrite real data.
 */
export const InstrumentActions = ({
  remaining = 0,
  label = 'Save & continue',
  disabled,
  onPrepopulate,
}) => {
  const {id} = useParams();
  const showPrepopulate = isDev && !id && typeof onPrepopulate === 'function';

  return (
    <div className={styles.actions}>
      <div
        className={`${styles.actionStatus} ${
          remaining ? styles.actionStatusWarn : ''
        }`}>
        {remaining ? (
          <>
            <b>{remaining}</b> required field{remaining === 1 ? '' : 's'} still
            to fill on this screen
          </>
        ) : (
          <>All required fields on this screen are complete</>
        )}
      </div>
      {showPrepopulate && (
        <button
          type="button"
          className={styles.prepopulate}
          onClick={onPrepopulate}
          title="Dev only — fills this screen with sample data">
          Prepopulate
        </button>
      )}
      <SubmitButton disabled={disabled} label={label} />
    </div>
  );
};

export default InstrumentActions;
